import { render, staticRenderFns } from "./HistoryDetailCanceled.vue?vue&type=template&id=9ccb0e9a&"
import script from "./HistoryDetailCanceled.vue?vue&type=script&lang=ts&"
export * from "./HistoryDetailCanceled.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports